const indexItems = [
  { title: '明星私生活', count: '1,236篇', desc: '顶流艺人私密生活大起底', icon: 'ri-user-star-line', color: 'primary' },
  { title: '综艺节目爆料', count: '892篇', desc: '选秀真人秀幕后真相', icon: 'ri-tv-line', color: 'accent' },
  { title: '网红圈八卦', count: '1,580篇', desc: '千万网红背后的真实面孔', icon: 'ri-live-line', color: 'secondary' },
  { title: '影视剧组内幕', count: '645篇', desc: '片场冲突与潜规则揭秘', icon: 'ri-clapperboard-line', color: 'primary' },
  { title: '音乐圈风云', count: '432篇', desc: '歌手抄袭与版权纠纷实录', icon: 'ri-music-line', color: 'accent' },
  { title: '时尚圈黑料', count: '518篇', desc: '大牌代言背后的暗流涌动', icon: 'ri-shirt-line', color: 'secondary' },
  { title: '体育圈瓜田', count: '376篇', desc: '运动员私生活与转会内幕', icon: 'ri-basketball-line', color: 'primary' },
  { title: '商业大佬秘闻', count: '294篇', desc: '企业家不为人知的另一面', icon: 'ri-briefcase-line', color: 'accent' },
];

const colorMap: Record<string, string> = {
  primary: 'bg-primary-500/10 text-primary-500',
  accent: 'bg-accent-500/10 text-accent-500',
  secondary: 'bg-secondary-500/10 text-secondary-500',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">专题合集</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="group cursor-pointer bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-500/30 transition-all flex items-start gap-4"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl shrink-0 ${colorMap[item.color]}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
                <span className="text-[10px] text-foreground-400 bg-background-200 px-2 py-0.5 rounded">
                  {item.count}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}